export const CACHE_KEY_LIST_SERVICES = 'services';
export const CACHE_KEY_SERVICES = 'services-one';
export const ROUTE_PATH_SERVICES = '/settings/services';
export const TRANSLATION_PREFIX_SERVICES = 'services';

